import styled from 'styled-components';

/**
 * stile condiviso per i testi dei dati (valori) del riepilogo esteso.
 */
export const SummaryTextValue = styled.div`
  font-weight: 400;
  color: ${props => props.theme.colorText};
  font-size: ${props => props.theme.fontSizeLG}px;
  word-break: break-all;
`;
